/* eslint-disable complexity */
import { useSuspenseQuery } from '@apollo/client';
import { Termin } from '@/domain/termine/shared/types/Termin';
import { TerminWiederholung } from '@/domain/termine/shared/types/TerminWiederholung';
import { GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM } from '@/domain/termine/hooks/graphql/queries';
import { GetTagesDatenQuery } from '@/gql/graphql';

export function useTagesDaten(
  standortIds: string[],
  zeitraum: { von: string; bis: string },
) {
  const { data, error } = useSuspenseQuery<
    GetTagesDatenQuery,
    { standortIds: string[]; zeitraum: { von: string; bis: string } }
  >(GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM, {
    variables: { standortIds, zeitraum },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  if (error || !data) {
    return {
      termine: [],
      feiertage: [],
      kalender: [],
      error: error ?? new Error('No data'),
    };
  }

  const kalender = data.termine_termineKalenderByStandortIdAndZeitraum;
  const feiertage = data.termine_feiertageByStandortIdsAndZeitraum;

  const termineResult = kalender.flatMap((kalender) => kalender.termine);

  const termine: Termin[] = termineResult.map(
    (item) =>
      new Termin({
        beginn: item.beginn ?? '',
        datum: item.datum,
        ende: item.ende ?? '',
        id: item.id,
        standortId: item.standortId,
        idTerminkalender: item.terminKalenderId ?? undefined,
        image: item.image ?? undefined,
        markierung: item.markierung,
        titel: item.titel,
        wiederholung: TerminWiederholung[item.wiederholung],
        wiederholungBis: item.wiederholungBis ?? undefined,
        beschreibung: item.termineDetails?.beschreibung ?? '',
        specials: item.termineDetails?.specials ?? '',
      }),
  );

  return {
    termine,
    feiertage,
    kalender,
    error: null,
  };
}
